<template>
    <div class="gagd_home">
        <div class="g1">
            <div class="g1_cont">
                <p class="p1">创意基础课程</p>
                <p class="p2">GA&GD</p>
                <p class="p3">通识艺术 & 通识设计</p>
            </div>
        </div>
        <div class="g2">
            <div class="g2_cont">
                <div class="g2_item" @click="scrollg2item(0)">
                    <img src="../img/GAGD切图/Star 2.png" alt="">
                    <p>通识艺术（GA）介绍</p>
                </div>
                <div class="g2_item" @click="scrollg2item(1)">
                    <img src="../img/GAGD切图/Star 2.png" alt="">
                    <p>通识设计（GD）介绍</p>
                </div>
                <div class="g2_item" @click="scrollg2item(2)">
                    <img src="../img/GAGD切图/Star 2.png" alt="">
                    <p>RoSSo的服务与优势</p>
                </div>
            </div>
        </div>
        <div class="g3">
            <div class="g2_position">
            </div>
            <div class="g3_cont" style="margin-top: 70px;">
                <div class="g3_left">
                    <h1>什么是 “通识艺术” ？</h1>
                    <div><span>通识艺术（General Arts）</span>的课程旨在提供与帮助他们重新思考这个世界并创造属于孩子们未来发展的更多的可能性。 </div>
                    <p>
                        ✓ 最大限度的让孩子们学到国外最前沿的艺术思维衔接之后的作品集和院校课程 <br>
                        ✓ 让他们耐下心来打磨自己的专业技法，为想法的施展铺好基石 <br>
                        ✓ 课程中尽可能增加趣味性，减少枯燥感 <br>
                        ✓ 课程之间保存相对的独立性，为插班的同学提供便利<br>
                    </p>
                </div>
                <img src="../img/GAGD切图/Group 687.png" alt="" class="g3_right">
            </div>
        </div>
        <div class="g4">
            <div class="section_title">
                <p class="section_cn">GA课程设置</p>
                <p class="section_en"></p>
            </div>
            <div class="g4_cont">
                <div class="g4_item">
                    <div class="show">
                        <p>古代艺术</p>
                        <img src="../img/GAGD切图/Group 691.png" alt="">
                    </div>
                    <div class="hid">
                        <p> ● 木刻版画 <br>
                            ● 铁丝雕塑头盔面具土著 （2次课 ） <br>
                            ● 埃及绘画 <br>
                            ● 希腊雕刻发泡板 （3次课 ）
                        </p>
                    </div>
                </div>
                <div class="g4_item">
                    <div class="show">
                        <p>中期艺术以及<br> 文艺复兴时期</p>
                        <img src="../img/GAGD切图/Group 691.png" alt="">
                    </div>
                    <div class="hid">
                        <p> ● 罗马建筑<br>
                            ● 中世纪艺术壁画 (2 次课 ) <br>
                            ● 透视学<br>
                            ● 文艺复兴 / 蛋彩画(2 次课)<br>
                            ● 十七世纪巴洛克<br>
                            ● 洛可可艺术<br>
                            ● 十八世纪新古典主义
                        </p>
                    </div>
                </div>
                <div class="g4_item">
                    <div class="show">
                        <p>后期艺术</p>
                        <img src="../img/GAGD切图/Group 691.png" alt="">
                    </div>
                    <div class="hid">
                        <p>
                            ● 浪漫主义 <br>
                            ● 前拉斐尔派 <br>
                            ● 后印象主义 <br>
                            ● 野兽派 <br>
                            ● 立体派 <br>
                            ● 达达主义 <br>
                            ● 超现实主义 / 产品设计
                        </p>
                    </div>
                </div>
                <div class="g4_item">
                    <div class="show">
                        <p>近代艺术</p>
                        <img src="../img/GAGD切图/Group 691.png" alt="">
                    </div>
                    <div class="hid">
                        <p> ● 包豪斯<br>
                            ● 抽象表现主义<br>
                            ● 欧普艺术<br>
                            ● 波普艺术<br>
                            ● 极简艺术
                        </p>
                    </div>
                </div>
                <div class="g4_item">
                    <div class="show">
                        <p>当代艺术</p>
                        <img src="../img/GAGD切图/Group 691.png" alt="">
                    </div>
                    <div class="hid">
                        <p>
                            ● 大地艺术<br>
                            ● 观念艺术<br>
                            ● 行为艺术<br>
                            ● 装置艺术<br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="g5">
            <div class="g5_cont">
                <div class="g5_left">
                    <h1>往期</h1>
                    <p>优秀作品</p>
                    <div>GA artworks</div>
                </div>
                <div class="g5_right">
                    <div class="g5_item g5_item1">
                        <img src="../img/GAGD切图/10018.jpg" alt="">
                    </div>
                    <div class="g5_item g5_item1">
                        <img src="../img/GAGD切图/10016.jpg" alt="">
                    </div>
                    <div class="g5_item g5_item2">
                        <img src="../img/GAGD切图/10021.jpg" alt="">
                    </div>
                    <div class="g5_item g5_item1">
                        <img src="../img/GAGD切图/10019.jpg" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="g3">
            <div class="g2_position">
            </div>
            <div class="g3_cont">
                <div class="g3_left">
                    <h1>什么是 “通识设计” ？</h1>
                    <div><span>通识设计（General Design）</span>课程五大板块囊括 2D 平面、多媒体、3D 立体设计，
                        时尚服装和艺术赏析，涵盖设计专业行业每个角落。每一个板块细分为 12 个专业项目，具体了解不同方向每个专业的特点，每节课都会覆盖理论，赏析和实践三个方面，
                        对于该学科进行剖析学习，并产出成果。使学员通过全专业多面覆盖的完整课程体系，建立起设计类学科的宏观理解和立体知识网络。 </div>
                    <p>
                        在这整套课程学习中，学员不仅能够了解认识设计，更能习得设计思维的思考技巧，如何收集信息从中提取、整合概念想法，梳理思路并进行二次创作。能够成为对学员今后无论在高等院校的深造学习还是未来的职业生涯助力。
                    </p>
                </div>
                <img src="../img/GAGD切图/Group 689.png" alt="" class="g3_right">
            </div>
        </div>
        <div class="g4">
            <div class="section_title">
                <p class="section_cn">GD课程设置</p>
                <p class="section_en"></p>
            </div>
            <div class="g4_cont">
                <div class="g4_item g4_item2">
                    <div class="show">
                        <p>2D平面设计基础</p>
                        <img src="../img/GAGD切图/Group 691.png" alt="">
                    </div>
                    <div class="hid">
                        <p> ● 平面设计<br>
                            ● 插画设计<br>
                            ● 交互设计
                        </p>
                    </div>
                </div>
                <div class="g4_item g4_item2">
                    <div class="show">
                        <p>多媒体设计基础</p>
                        <img src="../img/GAGD切图/Group 691.png" alt="">
                    </div>
                    <div class="hid">
                        <p>● 动画游戏设计<br>
                            ● 摄影<br>
                            ● 电影
                        </p>
                    </div>
                </div>
                <div class="g4_item g4_item2">
                    <div class="show">
                        <p>3D立体设计基础</p>
                        <img src="../img/GAGD切图/Group 691.png" alt="">
                    </div>
                    <div class="hid">
                        <p>
                            ● 室内设计 <br>
                            ● 建筑设计<br>
                            ● 景观设计<br>
                            ● 工业设计
                        </p>
                    </div>
                </div>
                <div class="g4_item g4_item2">
                    <div class="show">
                        <p>Fashion设计基础</p>
                        <img src="../img/GAGD切图/Group 691.png" alt="">
                    </div>
                    <div class="hid">
                        <p>● 服装设计<br>
                            ● 时尚造型<br>
                            ● 配饰设计
                        </p>
                    </div>
                </div>

            </div>
        </div>
        <div class="g5">
            <div class="g5_cont">
                <div class="g5_left">
                    <h1>往期</h1>
                    <p>优秀作品</p>
                    <div>GD artworks</div>
                </div>
                <div class="g5_right">
                    <div class="g5_item g5_item1">
                        <img src="../img/GAGD切图/10025.jpg" alt="">
                    </div>
                    <div class="g5_item g5_item2">
                        <img src="../img/GAGD切图/10026.jpg" alt="">
                    </div>
                    <div class="g5_item g5_item1">
                        <img src="../img/GAGD切图/10023.jpg" alt="">
                    </div>

                    <div class="g5_item g5_item1">
                        <img src="../img/GAGD切图/10024.jpg" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="a4">
            <div class="g2_position">
            </div>
            <div class="section_title">
                <span class="section_cn">RoSSo的服务与优势</span>
                <p class="section_en"></p>
            </div>
            <div class="a4_cont">

                <div class="a4_main">
                    <div class="a4_main_left">
                        <div class="a4_main_left_item" @click="dotClick(0)" style="font-weight: bold;">
                            <p> </p>
                            <span>RoSSo服务</span>
                        </div>
                        <div class="a4_main_left_item" @click="dotClick(1)">
                            <p> </p>
                            <span>课程亮点</span>
                        </div>
                        <div class="a4_main_left_item" @click="dotClick(2)">
                            <p> </p>
                            <span>课外活动</span>
                        </div>
                    </div>
                    <div class="a4_main_right">
                        <div class="a4_main_dot">
                            <div class="a4_main_dot_prev" @click="a4prev">
                                <div class="line1"></div>
                                <div class="line2"></div>
                            </div>
                            <div class="a4_main_dot_next" @click="a4next">
                                <div class="line1"></div>
                                <div class="line2"></div>
                            </div>
                        </div>
                        <div class="a4_main_right_banner" id="a4banner">
                            <div class="a4_main_right_item a4_main_right_item1">
                                <div class="a4_main_right_item_title">RoSSo服务</div>

                                <div class="a4_main_right_item_cont2 a4_cont_height">
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">课堂学习 </p>
                                        <p class="en">实时跟踪</p>
                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">作品整理
                                        </p>
                                        <p class="en">收集成册</p>
                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">学习情况
                                        </p>
                                        <p class="en">详细反馈</p>
                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">定期电话
                                        </p>
                                        <p class="en">汇报成果</p>
                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">一对一专属</p>
                                        <p class="en">升学指导规划 </p>
                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">校外点睛拓展 </p>
                                        <p class="en">视野与技能课程 </p>
                                    </div>

                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">作品展览演出</p>

                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">家长会</p>

                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">学员生日会</p>

                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">RoSSo</p>
                                        <p class="en">音乐与艺术系列 </p>
                                        <p class="cn">讲堂与体验</p>
                                    </div>
                                </div>
                            </div>
                            <div class="a4_main_right_item a4_main_right_item2">
                                <div class="a4_main_right_item_title">课程亮点</div>
                                <div class="a4_main_right_item_cont a4_cont_height">
                                    <div class="a4_main_right_item_cont_item">
                                        <img src="../img/GAGD切图/Rectangle 1098.jpg" alt="">
                                        <p class="p1">01. 在读情况月度总结</p>
                                        <p class="p2">月度学习成果汇报，反馈进步之处以及薄弱环节改进的建议</p>
                                    </div>
                                    <div class="a4_main_right_item_cont_item">
                                        <img src="../img/GAGD切图/Rectangle 1269.jpg" alt="">
                                        <p class="p1">02. 在校成绩跟踪</p>
                                        <p class="p2">每学期 GPA 情况跟踪了解以及针对学校选课提供建议</p>
                                    </div>
                                    <div class="a4_main_right_item_cont_item">
                                        <img src="../img/GAGD切图/Rectangle 1271.jpg" alt="">
                                        <p class="p1">03. 语言考试规划 / 建议</p>
                                        <p class="p2">升学需要哪些语言成绩，目标分各是多少，升学早期语言该如何准备，考试时间如何安排</p>
                                    </div>
                                    <div class="a4_main_right_item_cont_item">
                                        <img src="../img/GAGD切图/Rectangle 1272.jpg" alt="">
                                        <p class="p1">04. 背景提升，课外活动规划 / 建议</p>
                                        <p class="p2">升学的助力加分项目:夏校、竞赛如何选择，课外活动如何安排等</p>
                                    </div>
                                    <div class="a4_main_right_item_cont_item">
                                        <img src="../img/GAGD切图/Rectangle 1275.jpg" alt="">
                                        <p class="p1">05. 国高择校指导 / 建议</p>
                                        <p class="p2">如何选择国际课程和国际高中，与未来留学方向是否匹配</p>
                                    </div>
                                    <div class="a4_main_right_item_cont_item">
                                        <img src="../img/GAGD切图/Rectangle 1276.jpg" alt="">
                                        <p class="p1">06. 6次家长知识普及课堂</p>
                                        <p class="p2">升学情况指导，假期规划安排，校外活动补充，学习心理压力调节，艺术启蒙与综合提升等</p>
                                    </div>


                                </div>
                            </div>
                            <div class="a4_main_right_item a4_main_right_item3">
                                <div class="a4_main_right_item_title">课外活动</div>
                                <div class="a4_main_right_item3_cont a4_cont_height">
                                    <p class="a43_p">
                                        ● 全年 2 回 General Design Show 舞台汇报演出 : Summer Performance:6 月 12 日 & Winter
                                        Performance:1 月 25 日<br>
                                        ● 全年 6 回 Arts with Design Field Trip 实地考察旅行<br>
                                        ● 海外教授短期课 — RoSSo 每年会多次邀请到海外顶级艺术院校的教授为同学们进行短期课、讲座、线上课等，来帮助大家在不同的
                                        阶段改进自己的作品，为最后最优秀的作品集努力。</p>
                                    <div>
                                        <img src="../img/GAGD切图/10002.jpg" alt="">
                                        <img src="../img/GAGD切图/10004.jpg" alt="">

                                    </div>
                                </div>
                            </div>
                            <div class="a4_main_right_item a4_main_right_item1">
                                <div class="a4_main_right_item_title">RoSSo服务</div>

                                <div class="a4_main_right_item_cont2 a4_cont_height">
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">课堂学习 </p>
                                        <p class="en">实时跟踪</p>
                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">作品整理
                                        </p>
                                        <p class="en">收集成册</p>
                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">学习情况
                                        </p>
                                        <p class="en">详细反馈</p>
                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">定期电话
                                        </p>
                                        <p class="en">汇报成果</p>
                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">一对一专属</p>
                                        <p class="en">升学指导规划 </p>
                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">校外点睛拓展 </p>
                                        <p class="en">视野与技能课程 </p>
                                    </div>

                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">作品展览演出</p>

                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">家长会</p>

                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">学员生日会</p>

                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">RoSSo</p>
                                        <p class="en">音乐与艺术系列 </p>
                                        <p class="cn">讲堂与体验</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section_inp">
            <div class="s_inp_left">
                <img src="../img/shouchahua.png" alt="" class="img_shou  wow rotateInDownLeft" id="imgShou">
                <img src="../img/GAGD切图/Group 690.png" alt="" class="img_text  wow rollIn" id="imgText">
            </div>
            <div class="s_inp_right">
                <el-form :inline="true" :label-position="labelPosition" label-width="150px" :model="formLabelAlign">
                    <el-form-item label="姓名：">
                        <el-input v-model="formLabelAlign.name" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="意向专业：" class="elitem2">
                        <el-select v-model="formLabelAlign.region" placeholder="选择意向专业">
                            <el-option label="服装设计" value="服装设计"></el-option>
                            <el-option label="景观设计" value="景观设计"></el-option>
                            <el-option label="工业设计" value="工业设计"></el-option>
                            <el-option label="插画设计" value="插画设计"></el-option>
                            <el-option label="动画设计" value="动画设计"></el-option>
                            <el-option label="建筑设计" value="建筑设计"></el-option>
                            <el-option label="交互设计" value="交互设计"></el-option>
                            <el-option label="室内设计" value="室内设计"></el-option>
                            <el-option label="其他" value="其他"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="电话：">
                        <el-input v-model="formLabelAlign.tel" placeholder="请输入电话号码"></el-input>
                    </el-form-item>
                    <el-form-item label="意向国家：" class="elitem2">
                        <el-select v-model="formLabelAlign.region2" placeholder="选择意向国家">
                            <el-option label="英国" value="England"></el-option>
                            <el-option label="美国" value="America"></el-option>
                            <el-option label="日本" value="Japan"></el-option>
                            <el-option label="新加坡" value="Singapore"></el-option>
                            <el-option label="韩国" value="Korea"></el-option>
                            <el-option label="欧洲" value="Europe"></el-option>
                          
                            <el-option label="其他" value="Other"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="意向专业：">
                    <el-input v-model="formLabelAlign.major" placeholder="请输入意向专业"></el-input>
                </el-form-item> -->
                    <el-form-item class="yuyue_box">
                        <div class="yuyue" @click="onSubmit()"></div>
                    </el-form-item>
                </el-form>
            </div>
        </div>



    </div>
</template>
<script>
import "@/assets/css/gagd.css"
// import "@/assets/css/alevel.css"
import axios from "axios"
export default {
    data() {
        return {
            a4i: 0,

            formLabelAlign: {
                name: '',
                tel: '',
                region: '',
                region2: '',
                major: '',
            },
            labelPosition: 'right',

        }
    },
    methods: {
        scrollg2item(val) {

            var g2_position = document.getElementsByClassName("g2_position")
            var g2_item = document.getElementsByClassName("g2_item")
            for (var i = 0; i < g2_item.length; i++) {
                g2_item[i].style.opacity = "0.5"
            }
            g2_item[val].style.opacity = "1"
            g2_position[val].scrollIntoView({
                block: 'start',
                behavior: 'smooth',

            })
        },
        onSubmit() {
            // console.log('submit!',this.formInline);
            var currentURL = window.location.href;
            var status = ''
            // 检查 URL 中是否包含某些关键词，来判断使用的搜索引擎
            if (currentURL.includes("google")) {
                status = "用户正在使用 Google 搜索引擎"
            } else if (currentURL.includes("bing")) {
                status = "用户正在使用 Bing 搜索引擎"
            } else if (currentURL.includes("yahoo")) {
                status = "用户正在使用 Yahoo 搜索引擎"
            } else if (currentURL.includes("baidu")) {
                status = "用户正在使用 百度 搜索引擎"
            } else {
                status = "无法确定用户使用的搜索引擎"
            }
            var patt = /^1[3-9][0-9]{9}$/

            if (this.formLabelAlign.name == "" || this.formLabelAlign.tel == "") {
                // console.log("姓名和手机号不能为空");
                this.$message.error('姓名和手机号不能为空');

            } else {
                // console.log("不是空");

                if (patt.test(this.formLabelAlign.tel)) {

                    // console.log("可以发请求");
                    // console.log(this.formInline);
                    axios.post("https://public.rossoarts.com/index/common/getform", {
                        "name": this.formLabelAlign.name,
                        "tel": this.formLabelAlign.tel,
                        "major": this.formLabelAlign.major,
                        "intended_country":this.formLabelAlign.region2,
                        "url": window.location.href,
                        "status":status,
                    }).then((data) => {
                        console.log(data, "response");
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    }).catch(function (error) {
                        console.log(error, "error");
                    });

                } else {
                    console.log("手机号格式不正确");
                    this.$message.error('手机号格式不正确');

                }

            }


        },
        dotClick(val) {
            // console.log(val);
            var a4_main_left_item = document.getElementsByClassName("a4_main_left_item")
            for (var i = 0; i < a4_main_left_item.length; i++) {
                a4_main_left_item[i].style.fontWeight = "400"
            }
            a4_main_left_item[val].style.fontWeight = "bold"
            this.a4i = val
            a4banner.style.transform = `translateX(${-915 * this.a4i}px)`
            a4banner.style.height  = $(".a4_cont_height").eq(this.a4i).height() +120+ "px"
            // console.log($(".a4_cont_height").eq(this.a4i).height(),"0717");
        },
        a4next() {
            var a4_main_left_item = document.getElementsByClassName("a4_main_left_item")
            // var a4_main_right_item = document.getElementsByClassName("a4_main_right_item")
            this.a4i++;
            // console.log(a4_main_right_item[this.a4i]);
            // a4banner.style.height = a4_main_left_item[this.a4i].style.height
            a4banner.style.transform = `translateX(${-915 * this.a4i}px)`
            a4banner.style.transition = 'all .36s'
            if (this.a4i == 3) {
                this.a4i = 0;
                setTimeout(() => {
                    a4banner.style.transform = 'translate(0,0)';
                    a4banner.style.transition = 'none'
                }, 360);

            }
            for (var i = 0; i < a4_main_left_item.length; i++) {
                a4_main_left_item[i].style.fontWeight = "400"
            }
            a4_main_left_item[this.a4i].style.fontWeight = "bold"
            a4banner.style.height  = $(".a4_cont_height").eq(this.a4i).height() +120+ "px"
        },
        a4prev() {
            var a4_main_left_item = document.getElementsByClassName("a4_main_left_item")
            this.a4i--;
            if (this.a4i == -1) {
                this.a4i = 2;//length - 1

                a4banner.style.transition = 'none'

                a4banner.style.transform = `translateX(${-915 * (this.a4i + 1)}px)`
                setTimeout(() => {
                    a4banner.style.transform = 'translateX(' + (-this.a4i * 915) + 'px)';
                    a4banner.style.transition = 'all .36s'
                }, 1);

            } else {
                a4banner.style.transition = 'all 0.36s'
                a4banner.style.transform = `translateX(${-915 * this.a4i}px)`
            }
            for (var i = 0; i < a4_main_left_item.length; i++) {
                a4_main_left_item[i].style.fontWeight = "400"
            }
            a4_main_left_item[this.a4i].style.fontWeight = "bold"
            a4banner.style.height  = $(".a4_cont_height").eq(this.a4i).height() +120+ "px"
        },
    },
    mounted() {

    }
}
</script>